import { __assign } from '../../external/tslib/tslib.es6.mjs.js';
import { jsx } from 'react/jsx-runtime';
import { MaskInput } from '../maskInput/MaskInput.js';

var maskOptions = { mask: '(000) 000-0000' };
var PhoneNumberInput = function (props) { return (jsx(MaskInput, __assign({}, props, { maskOptions: maskOptions, maxLength: 20 }))); };

export { PhoneNumberInput };
